import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RuntimeConfig } from '@app/runtime-config';
import { ApiResponse } from '@app/shared/models/api-response';
import { TenantResolverService } from '@app/shared/tenant-resolver.service';
import { Tenant } from '@app/tenants/models/tenant';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigService {

	constructor (
		private http: HttpClient,
		private runtimeConfig: RuntimeConfig,
		private tenantResolver: TenantResolverService
	) { }

	load (): Promise<Tenant> {
		const tenant = this.tenantResolver.getTenantIdentity();
		if (!tenant) {
			throw Error('Tenant cannot be found.');
		}

		let env = '';
		if (environment.hasOwnProperty('env')) {
			env = `.${ environment['env'] }`;
		}

		const appSettings = `settings/appsettings${ env }.json`;
		const promise = lastValueFrom(this.http.get<RuntimeConfig>(appSettings))
			.then(config => this.setConfigAndFindTenant(config, tenant))
			.then((tenant) => {
				this.runtimeConfig.tenant = tenant.records;
				return tenant.records;
			});

		return promise;
	}

	private setConfigAndFindTenant (config: RuntimeConfig, tenant: string): Promise<ApiResponse<Tenant>> {
		this.runtimeConfig.appSettings = config.appSettings;
		return lastValueFrom(this.http.get<ApiResponse<Tenant>>(this.clientInformationUrl(tenant)));
	}

	private clientInformationUrl (tenant: string): string {
		return `${ this.runtimeConfig.appSettings.apiEndpoints.tenantService.url }/${ this.runtimeConfig.appSettings.apiEndpoints.tenantService.version }/tenant/${ tenant }/client-information`;
	}
}